import { ApolloLink } from './ApolloLink.js';

export const execute = ApolloLink.execute;
